import React, { useState } from 'react';
import { FaBell, FaBroadcastTower, FaMusic } from 'react-icons/fa';
import { NOTIFICATION_TYPES, NOTIFICATION_VISUALS } from '../../_helpers/notifications.js';

/** How long the amount reads, so the tile can step its font down: s ("$5"), m ("$5.50"), l ("$120.50"). */
const amountLength = (amount) => (amount.length <= 3 ? 's' : amount.length <= 5 ? 'm' : 'l');

/** The placeholder's icon: a note for a song, a tower for a go-live, a bell for anything else. */
const placeholderIcon = (tile, type) => {
  if (tile?.kind === NOTIFICATION_VISUALS.SONG) return FaMusic;
  if (typeof type === 'string' && type.startsWith(NOTIFICATION_TYPES.LIVE_STREAM)) return FaBroadcastTower;
  return FaBell;
};

/**
 * A feed notification's leading tile (ENG-889), from `notificationTile`: the
 * song's cover art, the band image, or the tip amount set in type. Images are
 * tried in order (a song's cover, then its band's image) and a tile whose
 * images are all missing or fail to load becomes a placeholder. Every variant
 * takes the same `className`, so the tile has one size whatever it shows and
 * the list does not shift when an image fails.
 *
 * Decorative: the row's text already says what the tile shows.
 */
function NotificationTile({ tile, type, className, emptyClassName, moneyClassName }) {
  const [failed, setFailed] = useState(() => new Set());

  if (tile?.kind === NOTIFICATION_VISUALS.MONEY && tile.amount) {
    return (
      <span className={`${className} ${moneyClassName}`} aria-hidden="true" data-visual="money" data-length={amountLength(tile.amount)}>
        {tile.amount}
      </span>
    );
  }

  const src = (tile?.sources ?? []).find((url) => !failed.has(url));
  if (src) {
    return (
      <img
        className={className}
        src={src}
        alt=""
        data-visual={tile.kind}
        onError={() => setFailed((previous) => new Set(previous).add(src))}
      />
    );
  }

  const Icon = placeholderIcon(tile, type);
  return (
    <span className={`${className} ${emptyClassName}`} aria-hidden="true" data-visual="placeholder">
      <Icon />
    </span>
  );
}

export default NotificationTile;
